import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { baseUrl } from '../../../common/constants/endpoints.constants';
import { PlanUsageResponse } from './plan-usage.model';

@Injectable({ providedIn: 'root' })
export class PlanUsageService {
  private readonly http = inject(HttpClient);

  get() {
    return this.http.get<PlanUsageResponse>(`${baseUrl}/dashboard/plan`);
  }
}
